import { IconBook2, IconComponents, type Icon } from "@tabler/icons-react";

import routes from "@features/routes";

export const MOBILE_HIDDEN_HEADER_ACTION_CLASS = "hidden md:inline-flex";

export type PageHeaderUtilityActionId = "documentation" | "design-system";

export type PageHeaderUtilityAction = {
  id: PageHeaderUtilityActionId;
  label: string;
  ariaLabel: string;
  href: string;
  Icon: Icon;
  headerClassName: string;
};

export const buildPageHeaderUtilityActions = ({
  showDesignSystem,
}: {
  showDesignSystem: boolean;
}): PageHeaderUtilityAction[] => [
  {
    id: "documentation",
    label: "Документация",
    ariaLabel: "Документация",
    href: routes.documents_system.pages.home.path(),
    Icon: IconBook2,
    headerClassName: MOBILE_HIDDEN_HEADER_ACTION_CLASS,
  },
  ...(showDesignSystem
    ? [
        {
          id: "design-system" as const,
          label: "Design System",
          ariaLabel: "Design System",
          href: routes.design_system.pages.home.path(),
          Icon: IconComponents,
          headerClassName: MOBILE_HIDDEN_HEADER_ACTION_CLASS,
        },
      ]
    : []),
];
